import Vue from 'vue';
import { apiPath } from '../constants';

export default Vue.resource(
  `${apiPath}{/apiVersion}/finance/invoices{/id}/`,
  {},
  {
    getInvoiceRange: {
      method: 'GET',
      url: `${apiPath}/invoice-ranges/`,
      responseType: 'json',
    },
    sendInvoiceToEmail: {
      method: 'GET',
      params: {
        apiVersion: 'v3',
      },
    },
  },
  { responseType: 'blob' },
);
